export const BASE_URL = process.env.REACT_APP_BASE_URL + 'api/';

/** Base for `version-node-copy/create` (port 5001 in local setups). Falls back to main API when unset. */
export const VERSION_NODE_COPY_BASE_URL =
  (process.env.REACT_APP_VERSION_NODE_COPY_BASE_URL || process.env.REACT_APP_BASE_URL) +
  'api/';

// Removed "api/" from the end of the URL
export const BASE = process.env.REACT_APP_BASE_URL

